// extracted by mini-css-extract-plugin
export default {"PageLayout":"PageLayout_PageLayout__aeuXc","noPadding":"PageLayout_noPadding__TeZud","fullWidth":"PageLayout_fullWidth__DumsP","fullHeight":"PageLayout_fullHeight__wUxzx"};